import { filter, find } from 'lodash'
import actions from './notificationActions'

// Initial state
export const initialState = {
    modal: {
        type: null,
        title: null,
        text: null,
        blocking: false,
        actions: [], // list of { text, [action], [color] } for each button
        callback: null, // fired when modal is dismissed
    },
}

export const mutations = {
    CLEAN (state) {
        Object.assign(state, initialState)
    },
    CLEAN_MODAL (state) {
        state.modal = initialState.modal
    },
    MODAL (state, data) {
        modalWithType(state, data)
    },
}

// HELPERS:
export function modalWithType (state, data) {
    if (typeof state !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : state is not an object', state)
        return
    }
    if (typeof data !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : data is not an object', data)
        return
    }
    if (typeof data.title !== 'string' || data.title.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : data.title is not valid', data.title)
        return
    }
    if (typeof data.text !== 'string' || data.text.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : data.text is not valid', data.text)
        return
    }
    if (data.actions) {
        if (!Array.isArray(data.actions)) {
            // eslint-disable-next-line no-console
            console.warn('store.notification.modalWithType : actions is not valid', data.actions)
        } else if (find(data.actions, ({ text }) => !text || typeof text !== 'string')) {
            // eslint-disable-next-line no-console
            console.warn('store.notification.modalWithType : actions has an element without text field', data.actions)
        }
    }
    if (data.callback && typeof data.callback !== 'function') {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : callback is not valid', data.callback)
    }
    if (data.blocking && typeof data.blocking !== 'boolean') {
        // eslint-disable-next-line no-console
        console.warn('store.notification.modalWithType : blocking is not valid', data.blocking)
    }
    state.modal = {
        title: data.title,
        text: data.text,
        blocking: typeof data.blocking === 'boolean' ? data.blocking : initialState.modal.blocking,
        actions: Array.isArray(data.actions) ? filter(data.actions, ({ text }) => text && typeof text === 'string') : initialState.modal.actions,
        callback: typeof data.callback === 'function' ? data.callback : initialState.modal.callback,
    }
}

export default {
    namespaced: true,
    state: {
        ...initialState,
    },
    actions,
    mutations,
}
